var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 12c0-5.357 4.343-9.7 9.7-9.7 5.357 0 9.7 4.343 9.7 9.7 0 5.357-4.343 9.7-9.7 9.7-5.357 0-9.7-4.343-9.7-9.7ZM12 3.7a8.3 8.3 0 0 0-.7 16.57v-6.284H8.786v-1.4H11.3v-1.872a3.271 3.271 0 0 1 3.271-3.271h.643v1.4h-.643a1.871 1.871 0 0 0-1.871 1.871v1.872h2.514v1.4H12.7v6.285A8.3 8.3 0 0 0 12 3.7Z",
    fill: "currentColor"
  })));
};
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "344c4cb6a3c2d3ffefdb8cef398601f6.svg";